export interface CookieServiceConfig {
    domain?: string;
    maxAge?: number;
}

/**
 * A service for reading, writing, and deleting cookies on the
 * client. Must be configured with a domain via config() before saveData()
 * or deleteDataById() will take effect; getDataById() works without config.
 *
 * TODO: A cookie utility function exist in utils/utils.service.ts, we can refactor later to use this class for all cookies
 */
export class CookieService {
    private static _instance: CookieService;
    private _domain?: string;
    private _maxAge = 60 * 60 * 24 * 365;

    public static get Instance(): CookieService {
        if (!CookieService._instance) {
            CookieService._instance = new CookieService();
        }
        return CookieService._instance;
    }

    public config(config: CookieServiceConfig = {}) {
        if (config.domain !== undefined) {
            this._domain = config.domain;
        }
        if (config.maxAge !== undefined) {
            this._maxAge = config.maxAge;
        }
    }

    public get isConfigured(): boolean {
        return !!this._domain;
    }

    public getDataById(id: string): string | null {
        if (typeof document === 'undefined') {
            return null;
        }

        const match = document.cookie.match(
            new RegExp(`(?:^|; )${id.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`)
        );

        return match ? decodeURIComponent(match[1]) : null;
    }

    public saveData(id: string, data: string): void {
        if (!data || !this._domain || typeof document === 'undefined') {
            return;
        }

        const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
        const base = `path=/; SameSite=Lax; max-age=${this._maxAge}${secure ? '; Secure' : ''}; domain=${this._domain}`;

        document.cookie = `${id}=${encodeURIComponent(data)}; ${base}`;
    }

    public deleteDataById(id: string): void {
        if (!this._domain || typeof document === 'undefined') {
            return;
        }

        const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
        const base = `path=/; SameSite=Lax; max-age=0${secure ? '; Secure' : ''}; domain=${this._domain}`;

        document.cookie = `${id}=; ${base}`;
    }
}
